module.exports = __webpack_public_path__ + "img/shark.fc553727.png";